import { UserCheck, Building2, ShieldCheck, HeartPulse, Scale } from "lucide-react";

const badges = [
  { icon: UserCheck, label: "Independent Licensed Providers" },
  { icon: Building2, label: "U.S.-Based Pharmacies" },
  { icon: ShieldCheck, label: "HIPAA Compliant" },
  { icon: HeartPulse, label: "Ongoing Monitoring" },
  { icon: Scale, label: "Provider Autonomy" },
];

const SafetySection = () => {
  return (
    <section className="py-24 bg-secondary/50">
      <div className="container mx-auto px-4 text-center max-w-3xl">
        <p className="text-sm font-semibold uppercase tracking-widest text-champagne mb-3">
          Safety & Trust
        </p>
        <h2 className="font-display text-4xl md:text-5xl text-foreground mb-4">
          Your health comes first.
        </h2>
        <p className="text-muted-foreground text-lg mb-12 max-w-xl mx-auto">
          All treatments are prescribed by licensed medical providers and tailored to your individual needs.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
          {badges.map((b) => (
            <div key={b.label} className="flex flex-col items-center gap-3 p-5 rounded-2xl bg-card border border-border">
              <div className="w-11 h-11 rounded-xl bg-primary/10 flex items-center justify-center">
                <b.icon size={20} className="text-primary" />
              </div>
              <span className="text-sm font-medium text-foreground text-center">{b.label}</span>
            </div>
          ))}
        </div>
        <p className="text-xs text-muted-foreground mt-8 max-w-xl mx-auto">
          All providers on the Elara Health platform are independently licensed clinicians who make autonomous clinical decisions. Elara Health does not direct or influence medical recommendations.
        </p>
      </div>
    </section>
  );
};

export default SafetySection;
